import ClientPp1 from '../assets/images/login/testimoni/havida.jpg'
import ClientPp2 from '../assets/images/login/testimoni/stephane.jpeg'
import ClientPp3 from '../assets/images/login/testimoni/nurul.jpeg'

export const testimoni = [
  {
    name: 'Havida',
    job: 'HR - Geprekin',
    title: 'Aplikasi Kerjoo Lengkap, Bikin Tenang Manajemen',
    message: 'Sejak menggunakan Kerjoo, pengelolaan SDM perusahaan kami menjadi jauh lebih terstruktur dan efisien. Semua kebutuhan absensi, jadwal kerja, dan update data karyawan bisa dilakukan dalam satu aplikasi saja. Kerjoo juga dilengkapi fitur deteksi kecurangan presensi, sehingga manajemen lebih tenang. Terima kasih Kerjoo, benar-benar solusi modern untuk HR!',
    image: ClientPp1,
  },
  {
    name: 'Stephane T.E. Assa',
    job: 'Staf SDM - PDAB Tirtatama Daerah Istimewa Yogyakarta',
    title: 'Laporan Lebih Mudah, Data Terjamin Aman',
    message: 'Aplikasi online Kerjoo memudahkan karyawan dan juga tim SDM dalam membuat laporan. Tim Kerjoo juga sangat cepat dalam memberikan informasi dan menjamin kerahasiaan data. Semoga kerjasama terus berlanjut. Terima kasih kerjoo.com.',
    image: ClientPp2,
  },
  // {
  //   name: 'Aviawan Azhari',
  //   job: 'Masterpulsa Grup',
  //   title: 'Fitur Lengkap, Customer Service Fast Response',
  //   message: 'Puas dengan pelayanan after salesnya. Fitur versi web komplit, data yang disajikan lengkap, fitur versi mobile simple dan mudah dipakai. Yang jelas customer service sangat fast response.',
  //   image: ClientPp2,
  // },
  {
    name: 'Nurul Karlina',
    job: 'HRD - IDwebhost',
    title: 'Meningkatkan Efektivitas dan Efisiensi Monitoring Kehadiran Karyawan',
    message: 'Aplikasi presensi mobile yang mudah diakses dengan fitur-fitur yang dapat meningkatkan efektivitas dan efisiensi monitoring kehadiran karyawan WFO dan WFH. Benar-benar solusi di masa pademi seperti ini. Terimakasih untuk tim Kerjoo. Semakin sukses!',
    image: ClientPp3,
  },
  // {
  //   name: 'Gusti Chandra',
  //   job: 'Project Manager - PT. Potensi Media Elaborasi',
  //   message:
  //     '“Dengan Kerjoo sekarang kami jadi lebih mudah cek Lokasi Kehadiran,cek Absensi, Foto & Izin Karyawan. yang sebelumnya proses panjang dan membutuhkan waktu lama, sekarang selesai hanya dalam beberapa menit. Bangga dengan Tim beserta Developernya, semoga makin berkembang dan maju.”',
  //   image: ClientPp4,
  // },
  // {
  //   name: 'Ahmad Ridwan',
  //   job: 'Mobile Concrete 1 - Wika Beton',
  //   message:
  //     '“Untuk beberapa waktu kami mencoba untuk trial dan memberikan hasil yang cukup baik… sekarang kami sudah mencoba cakupan yang lebih besar, kerjoo mudahkan harimu.”',
  //   image: ClientPp5,
  // },
  // {
  //   name: 'Febri Hantari',
  //   job: 'HRD - HOV Group',
  //   message:
  //     '“Sistem absensi kerjoo sangat membantu saya dalam pendataan data karyawan serta absensi hingga penggajian. Dalam pelayanan baik masa trial sampai pasca bayar tetap didampingi dan diberi pelayanan yang luar biasa. Costumer servisenya sangat ramah sehingga kami pengguna kerjoo mendapatkan informasi penggunaan dengan detail.”',
  //   image: ClientPp6,
  // },
  // {
  //   name: 'Ilvan Pamega',
  //   job: 'Notisnal Studio',
  //   message:
  //     '“Aplikasi presensi mobile yang mudah digunakan , memudahkan studio kami dalam menjalankan SOP kerja yang ada di studio notisnal, fitur lebih detail, dan cocok sekali untuk micro studio di bidang desain seperti kami, makasih kerjoo.”',
  //   image: ClientPp7,
  // },
  // {
  //   name: 'Sri Wahyuningsih',
  //   job: 'PT. Jabal Perkasa',
  //   message:
  //     '“Trims Team Kerjoo yang selalu bisa handle & kasih solusi ketika Kami ada trouble. Semua masalah absensi beres dengan Kerjoo.”',
  //   image: ClientPp9,
  // },
  // {
  //   name: 'Irfannu Sefandi',
  //   job: 'KSDM - Mobile Concrete 3',
  //   message: '“kerjoo KEREEEN !”',
  //   image: ClientPp8,
  // },
  // {
  //   name: 'Pontjo Mardijono',
  //   job: 'Sekretaris - Satuan Polisi Pamong Praja Kabupaten Wonogiri',
  //   message:
  //     '“Aplikasi Kerjoo memang mudah, murah dan handal. Dengan aplikasi absensi ini bisa meningkatkan disiplin dan kinerja anggota kami.”',
  //   image: ClientPp10,
  // },
]
